<div
  class="flex min-h-dvh w-full flex-col bg-linear-to-t from-white to-brand-primary-lightest"
  role="status"
  aria-live="polite"
>
  <header class="flex shrink-0 justify-center px-4 pt-8 pb-3">
    <div class="flex max-w-xs items-center justify-center">
      <img
        src="assets/images/logo-icon-LIV.webp"
        alt="Portal LIV"
        class="h-12 w-auto max-w-full object-contain object-center select-none"
      />
    </div>
  </header>

  <!-- Ocupa o espaço entre logo e rodapé e centra o bloco (vertical + horizontal). -->
  <div
    class="flex min-h-0 flex-1 flex-col items-center justify-center px-4 pt-4 pb-8 sm:px-6"
  >
    <div
      class="mx-auto flex w-full max-w-md flex-col items-center gap-8 text-neutral-low-dark"
    >
      <div class="flex shrink-0 flex-col items-center gap-3">
        <liv-spin-loader class="shrink-0" size="lg" variant="primary" />

        <div class="select-none">
          <h6 class="text-center font-roboto text-xl font-medium text-current">
            {{ titleKey() | translate }}
          </h6>
          <p class="text-center font-roboto text-base font-normal text-current">
            {{ messageKey() | translate }}
          </p>
        </div>
      </div>

      <span class="sr-only">{{ 'messages.loading' | translate }}</span>
    </div>
  </div>

  <footer class="flex shrink-0 justify-center px-4 pt-2 pb-6">
    <span class="text-xs text-neutral-low-light select-none">
      {{ 'messages.footer_copyright' | translate: { year: currentYear } }}
    </span>
  </footer>
</div>
